<ng-content></ng-content>
<div class="caption">
  <kb-line-clamp lines="2">
    <ng-content select="figcaption"></ng-content>
  </kb-line-clamp>
</div>
